import { render, staticRenderFns } from "./StoriesShape.vue?vue&type=template&id=62636d50&scoped=true&"
import script from "./StoriesShape.vue?vue&type=script&lang=js&"
export * from "./StoriesShape.vue?vue&type=script&lang=js&"
import style0 from "./StoriesShape.vue?vue&type=style&index=0&id=62636d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62636d50",
  null
  
)

export default component.exports